import React from 'react';
import { Svg } from '../../Svg/Svg';

interface RadioProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id?: string;
  label: string;
  name: string;
  value?: string;
  errorMessage?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
  isDisabled?: boolean;
}

const Radio: React.FC<RadioProps> = ({
  id,
  label,
  name,
  value,
  errorMessage,
  onChange,
  checked,
  isDisabled,
  ...otherProps
}) => {
  return (
    <div className={`mz-form-item mz-form-item--radio ${isDisabled ? 'disabled' : ''}`}>
      <label className="mz-form-item__inner" htmlFor={id}>
        <div className="mz-form-item__label-content">
          {label}
        </div>
        <input
          type="radio"
          className="mz-form-item__radio"
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          checked={checked}
          disabled={isDisabled}
          {...otherProps}
        />
        <div className="mz-form-item__checkmark">
          <Svg
            type="checkmark"
            size={1}
            colour="mz-svg--black"
          />
        </div>
        {errorMessage && (
          <div className="mz-form-item__error-message">{errorMessage}</div>
        )}
      </label>
    </div>
  );
};

export default Radio;
